import { observer } from 'mobx-react';
import { createForm } from '@seek/forms-ui';
import ActionableFormView, {
  type ActionableFormViewProps,
} from '../ActionableFormView';
import React from 'react';
import type { Locale } from '@seek/melways-sites';

export interface ActionableFormInputProps {
  useFormField?: any;
}

interface ActionableFormProviderProps<T extends Record<string, unknown>>
  extends ActionableFormViewProps {
  initialFormValues: T;
  locale?: Locale;
}

const { FormProvider, useField } = createForm();

// FIXME: Do not use React.cloneElement to clone children and pass in useField
// We should use render prop pattern here.
// This will help us avoid importing noop for useFormField every time we use ActionableFormProvider
const ActionableFormProvider = <T extends Record<string, unknown>>({
  initialFormValues,
  onSubmit,
  submitButtonLabel,
  submitButtonLoadingLabel,
  isStickyButtons,
  onCancel,
  onSubmitError,
  onSubmitErrorWithSetErrorMessage,
  onSubmitSuccess,
  children,
  locale = 'en-AU',
}: ActionableFormProviderProps<T>) => (
  <FormProvider language={locale} initialValues={initialFormValues}>
    {({ handleSubmit }) => (
      <ActionableFormView
        handleSubmit={handleSubmit}
        onCancel={onCancel}
        onSubmit={onSubmit}
        submitButtonLabel={submitButtonLabel}
        submitButtonLoadingLabel={submitButtonLoadingLabel}
        isStickyButtons={isStickyButtons}
        onSubmitSuccess={onSubmitSuccess}
        onSubmitError={onSubmitError}
        onSubmitErrorWithSetErrorMessage={onSubmitErrorWithSetErrorMessage}
      >
        {React.cloneElement(children, {
          useFormField: useField,
        })}
      </ActionableFormView>
    )}
  </FormProvider>
);

export { type ActionResult, failResult, okResult } from '../ActionableFormView';

export default observer(ActionableFormProvider);
